import './DeleteAccount.css';
import React, { useState } from 'react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { get, canUseDOM, getColorByTheme, getPageThemeColors } from '../../utils';
import { getLatestUserCookie, logoutUser } from './user_session';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import Modal from '../atoms/Modal/Modal';
import { useModal } from '../atoms/Modal/useModal';
import SelectFieldCustom from './components/SelectFieldCustom';
import { loaderToggle } from '../../utils/setUserCookie';
const DeleteAccount = _ref => {
  let {
    params,
    fields
  } = _ref;
  const loggedOut = 'LoggedOut';
  const generalErrorCode = 'Failed';
  let formPostErrors = [];
  let allErrors = [];
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const clientId = get(sitecoreContext, 'configuration.globalApi.clientId') || 'replaceint2';
  const clientSecret = get(sitecoreContext, 'configuration.globalApi.clientSecret') || 'replacesecret';
  const currentLang = get(sitecoreContext, 'language');
  const {
    isShown,
    toggle
  } = useModal();
  const identityGlobal = get(sitecoreContext, 'configuration.globalApi.identityGlobal') || 'https://replaceidentityGlobal';
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [deleteReason, setDeleteReason] = React.useState('');
  const [reasonsForRendering, setReasonsForRendering] = useState([{
    text: '',
    value: ''
  }]);
  const [formResponseError, setFormResponseError] = useState('');
  const [formSuccess, setFormSuccess] = useState(false);
  const reasons = get(fields, 'data.datasource.reasons') || [];
  const dictionaryValues = get(fields, 'data.dictionary.dictionaryValues') || [];
  const [isVdsite, setIsVdsite] = React.useState(true);
  React.useEffect(() => {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  const primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  const primaryActivePageThemeColor = get(sitecoreContext, 'themesOfPage.primary_active');
  const BackgroundColorHex = get(params, 'BackgroundColorHex');
  const ColorHex = get(params, 'ColorHex');
  const ActiveColorHex = get(params, 'ActiveColorHex');
  const selectedPrimaryColor = primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary;
  const selectedPrimaryActiveColor = primaryActivePageThemeColor ? primaryActivePageThemeColor : getPageThemeColors(isVdsite).primary_active;
  const variables = BackgroundColorHex ? {
    '--delete-profile-background-color': BackgroundColorHex,
    '--delete-profile-background-active-color': ActiveColorHex,
    '--delete-profile-color': ColorHex
  } : {
    '--delete-profile-background-color': selectedPrimaryColor,
    '--delete-profile-background-active-color': selectedPrimaryActiveColor,
    '--delete-profile-color': getColorByTheme(selectedPrimaryColor)
  };
  const mapDictionary = dictionaryValues.reduce((map, currentValue) => map.set(currentValue.key.jss.value, currentValue.phrase.jss.value), new Map());
  formPostErrors.push({
    errorCode: generalErrorCode,
    message: mapDictionary.get('changePasswordApiError') || ''
  });
  formPostErrors.push({
    errorCode: loggedOut,
    message: mapDictionary.get('user not logged in error message') || ''
  });
  const deleteAccountText = mapDictionary.get('deleteAccount');
  const deleteInfoText = mapDictionary.get('deleteInfo');
  const proceedText = mapDictionary.get('proceed');
  const cancelText = mapDictionary.get('cancel');
  const deleteInfoPopupText = mapDictionary.get('deleteInfoPopup');
  const deleteYourAccountText = mapDictionary.get('deleteYourAccount');
  const whyDeleteQuestionText = mapDictionary.get('whyDeleteQuestion');
  const placeholder = mapDictionary.get('pleaseSelect');
  const recaptchErrorMessage = mapDictionary.get('errorRecaptchaRequired');
  React.useEffect(() => {
    let arr = [];
    reasons.forEach(item => {
      arr.push({
        value: get(item, 'reason.jss.value'),
        label: get(item, 'reason.jss.value')
      });
    });
    setReasonsForRendering(arr);
  }, []);
  const handleCancelClick = () => {
    toggle();
    setFormResponseError('');
  };
  const handleButtonClick = () => {
    toggle();
  };

  // Show Form Response Errors
  const showResponseError = errorCode => {
    const errorObject = formPostErrors.find(errorItem => {
      return errorItem.errorCode === errorCode;
    });
    if (errorObject) {
      setFormResponseError(errorObject.message);
    } else {
      setFormResponseError(formPostErrors[0].message);
    }
  };
  const handleDelete = authToken => {
    let myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');
    myHeaders.append('Authorization', `Bearer ${authToken}`);
    let raw = `{
			"Lang" : "${currentLang}",
			"ClientId" : "${clientId}",
			"Reason" : "${deleteReason}"
		}`;
    let requestOptions = {
      method: 'POST',
      body: raw,
      headers: myHeaders,
      redirect: 'follow'
    };
    let statusCode = 0;
    fetch(`${identityGlobal}/api/user/Delete`, requestOptions).then(response => {
      loaderToggle(false, setDisableSubmit);
      statusCode = response.status;
      return response.text();
    }).then(result => {
      let responseObj;
      if (result) {
        responseObj = JSON.parse(result);
      }
      if (statusCode === 200) {
        if (responseObj.isSuccess) {
          setFormSuccess(true);
        } else if (!responseObj.isSuccess) {
          if (responseObj.errors && responseObj.errors.length) {
            throw Error(responseObj.errors[0].code);
          }
        }
        logoutUser(identityGlobal, clientId, clientSecret).then(response => {
          if (response) {
            window.location.href = '/';
          }
        });
      } else {
        throw Error(generalErrorCode);
      }
    }).catch(error => {
      console.log('error', error);
      loaderToggle(false, setDisableSubmit);
      if (statusCode === 0) {
        showResponseError(generalErrorCode);
      } else {
        showResponseError(error.message);
      }
    });
  };

  // Validate all fields on submit
  const validateAllFields = () => {
    let success = true;
    return success;
  };
  const formSubmit = event => {
    event.preventDefault();
    setFormResponseError('');
    if (validateAllFields()) {
      loaderToggle(true, setDisableSubmit);
      getLatestUserCookie(identityGlobal, clientId, clientSecret).then(response => {
        if (response.login_status) {
          if (response.error) {
            loaderToggle(false, setDisableSubmit);
            showResponseError(generalErrorCode);
          } else {
            handleDelete(response.access_token);
          }
        } else {
          loaderToggle(false, setDisableSubmit);
          showResponseError(loggedOut);
        }
      });
    }
  };
  let reasonsFieldProps = {
    value: deleteReason ? {
      value: deleteReason,
      label: deleteReason
    } : null,
    label: '',
    id: 'delete-reason',
    name: 'delete-reason',
    labelLight: false,
    autoComplete: 'delete-reason',
    required: false,
    changeEvent: value => {
      setDeleteReason(value);
    },
    blurEvent: value => {},
    options: reasonsForRendering,
    placeholder: placeholder
  };
  allErrors.push(reasonsFieldProps);
  if (!fields) {
    console.warn('Delete account component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, "['Delete account is empty: please provide datasource]");
    }
    return null;
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: "delete-acc col-xl-8 offset-xl-1",
    style: variables
  }, /*#__PURE__*/React.createElement("div", {
    className: "delete-acc__content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "delete-acc__header"
  }, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\u0421\u0433\u0440\u0443\u043F\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C_186",
    "data-name": "\u0421\u0433\u0440\u0443\u043F\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C 186",
    transform: "translate(-376 -747)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\u042D\u043B\u043B\u0438\u043F\u0441_80",
    "data-name": "\u042D\u043B\u043B\u0438\u043F\u0441 80",
    transform: "translate(376 747)",
    fill: "none",
    stroke: "var(--delete-profile-background-color)",
    "stroke-width": "2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "10",
    r: "10",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "10",
    r: "9",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\u0421\u0433\u0440\u0443\u043F\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C_157",
    "data-name": "\u0421\u0433\u0440\u0443\u043F\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C 157",
    transform: "translate(1879.223 -9641.982) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\u0421\u0433\u0440\u0443\u043F\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C_145",
    "data-name": "\u0421\u0433\u0440\u0443\u043F\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C 145",
    transform: "translate(1492.199 -10404.029)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\u041A\u043E\u043D\u0442\u0443\u0440_129",
    "data-name": "\u041A\u043E\u043D\u0442\u0443\u0440 129",
    d: "M6.5,9.677a.912.912,0,0,1-.913-.913V4.738a.913.913,0,1,1,1.826,0V8.764A.912.912,0,0,1,6.5,9.677Z",
    transform: "translate(-5.585 -3.825)",
    fill: "var(--delete-profile-background-color)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\u0421\u0433\u0440\u0443\u043F\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C_146",
    "data-name": "\u0421\u0433\u0440\u0443\u043F\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C 146",
    transform: "translate(1492.016 -10396.144)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\u042D\u043B\u043B\u0438\u043F\u0441_79",
    "data-name": "\u042D\u043B\u043B\u0438\u043F\u0441 79",
    cx: "1.095",
    cy: "1.095",
    r: "1.095",
    fill: "var(--delete-profile-background-color)"
  }))))), /*#__PURE__*/React.createElement("span", {
    className: "delete-acc__title"
  }, deleteAccountText)), /*#__PURE__*/React.createElement("p", {
    className: "delete-acc__notification"
  }, deleteInfoText)), /*#__PURE__*/React.createElement("div", {
    className: "delete-acc__cta"
  }, proceedText && /*#__PURE__*/React.createElement("button", {
    className: "btn btn-secondary delete-acc__btn",
    onClick: handleButtonClick,
    "data-cy": "proceed",
    tabIndex: 0
  }, proceedText))), /*#__PURE__*/React.createElement(Modal, {
    isShown: isShown,
    hide: handleCancelClick,
    style: {
      maxWidth: '520px'
    },
    primaryColor: selectedPrimaryColor,
    primaryActiveColor: selectedPrimaryActiveColor
  }, /*#__PURE__*/React.createElement("div", {
    className: "delete-account-modal"
  }, /*#__PURE__*/React.createElement("div", {
    className: "delete-account-modal__header"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "h3"
  }, deleteYourAccountText), /*#__PURE__*/React.createElement("span", {
    className: "delete-account-modal__text"
  }, deleteInfoPopupText)), /*#__PURE__*/React.createElement("div", {
    className: "delete-account-modal__content"
  }, /*#__PURE__*/React.createElement("form", {
    onSubmit: event => formSubmit(event),
    noValidate: true
  }, /*#__PURE__*/React.createElement("legend", {
    className: "accessibility-hidden-text"
  }, whyDeleteQuestionText), /*#__PURE__*/React.createElement("label", {
    className: "body-small wiz__label",
    htmlFor: "delete-account-reason"
  }, whyDeleteQuestionText), /*#__PURE__*/React.createElement(SelectFieldCustom, reasonsFieldProps), formResponseError && formResponseError.length ? /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-error-response"
  }, /*#__PURE__*/React.createElement("div", {
    className: "lr__error"
  }, formResponseError)))) : null, /*#__PURE__*/React.createElement("div", {
    className: "delete-account-modal__footer"
  }, /*#__PURE__*/React.createElement("button", {
    disabled: disableSubmit,
    className: "btn btn-primary delete-account-modal__btn-delete",
    type: "submit"
  }, deleteAccountText), /*#__PURE__*/React.createElement("button", {
    className: "btn btn-secondary delete-account-modal__btn-cancel",
    onClick: handleCancelClick
  }, cancelText))))))));
};
const StyledWrapper = _ref2 => {
  let {
    children,
    rtl
  } = _ref2;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    className: `${rtl ? rtlStyles : ltrStyles} ${commonStyles}`
  }, children);
};
const commonStyles = "cyslhjd";
const ltrStyles = "l1hqfdng";
const rtlStyles = "rz9gfvw";
export default DeleteAccount;